<template>
  <div>
    <div class="current-note relative">
      <div class="flex flex-row">
        <router-link
          :to="'/admin/notes/' + note.id + '/update'"
          data-cy="note-card-link"
        >
          <div v-if="note.book.type === 'date'">
            <h3>
              {{ note_date }}
              <span v-if="note.title">({{ note.title }})</span>
            </h3>
          </div>
          <div v-else>
            <h3 class="note-title">{{ note.title }}</h3>
          </div>
        </router-link>

        <div
          class="absolute right-0 flex flex-auto cursor-pointer text-gray-700"
          v-on:click="toggleOptions"
        >
          <Zondicon class="nav-icon w-4 h-4 fill-current" icon="Menu" />
        </div>
      </div>

      <div
        class="actions border-l border-r border-t absolute right-0 bg-white z-10"
        v-if="showOptions"
      >
        <note-options-dropdown
          :closeMenu="() => {showOptions = false;}"
          :note="note"
        ></note-options-dropdown>
      </div>

      <div v-on:click="oneClick">
        <div
            v-if="note.content && note.content.length > 400"
          class="w-1/5 py-5 absolute right-15 text-right"
          :style="`top: ${boxHeight}px;`"
          v-on:click="showContent = !showContent"
        >
          <Zondicon
              v-if="!showContent"
              class="w-8 fill-current cursor-pointer right-0 inline relative opacity-25"
              icon="CheveronDown"
          />
          <Zondicon
              v-else
              class="w-8 fill-current cursor-pointer right-0 inline relative opacity-25"
              icon="CheveronUp"
          />
        </div>
        <div v-if="noteIsProtectedAndNotUnlocked">
          <div v-on:click="$store.dispatch('aToggleUnlocker', {unlocking: note.book_id})">
            Locked
          </div>
        </div>
        <div
          :class="'note-content'" :style="showContent ? `` : `max-height: ${boxHeight}px; overflow-y: auto;`"
          v-html="note.content"
          v-else-if="!note.is_encrypted"
        ></div>
        <div
          :class="'note-content ' + showContent"
          v-else-if="note.is_encrypted && note.encrypter_id === user.encrypter.id"
          v-html="note.decrypted !== true ? 'Decrypting ' : note.encrypted"
        ></div>
        <!--                <decrypted-->
        <!--                    v-else-if="note.is_encrypted && note.encrypter_id === user.encrypter.id"-->
        <!--                    :class="'note-content ' + showContent"-->
        <!--                    :encrypted="note.encrypted"-->
        <!--                >-->
        <!--                </decrypted>-->
        <div
          v-else-if="
            note.is_encrypted && note.encrypter_id !== user.encrypter.id
          "
        >
          Cannot decrypt with new encryption key
        </div>
      </div>

      <div v-if="categories">Categories: {{ categories }}</div>
    </div>
  </div>
</template>

<script>
import Loading from "../ui/Loading.vue";
import moment from "moment";
import DREditor from "../DoxEditor.vue";
import vSelect from "vue-select";
import Decrypted from "./Decrypted.vue";
import { API_URL } from "../../env";
import NoteOptionsDropdown from "./NoteOptionsDropdown";

export default {
  components: {
    NoteOptionsDropdown,
    Loading,
    dreditor: DREditor,
    "v-select": vSelect,
    Decrypted
  },
  props: ["note"],
  data() {
    return {
      loading: false,
      showContent: false,
      editing: false,
      showOptions: false,
      delay: 700,
      clicks: 0,
      timer: null,
      boxHeight: 200,
    };
  },
  created() {
    // if (this.note.is_encrypted && !this.note.decrypted) {
    //     this.loading = true;
    //     this.decryptContent().then(() => {
    //         this.loading = false;
    //     });
    // }
  },
  computed: {
    ago: function() {
      var dateUtc = moment.utc(this.note.created_at);
      var localDate = moment(dateUtc).local();
      return localDate.fromNow();
    },
    date: function() {
      var dateUtc = moment.utc(this.note.created_at);
      var localDate = moment(dateUtc).local();
      return localDate.format("MMMM DD YYYY, h:mm:ss a");
      // return moment(this.note.created_at).format('MMMM DD YYYY, h:mm:ss a');
    },
    note_date: function() {
      if (this.note.book.type === "date") {
        // Subtract 4 (or 5) hours from the UTC datetime in the database to get local time for EST/EDT
        var localDate = moment(this.note.date).format("dddd, MMMM DD, YYYY");
        return localDate;
      }
    },
    timezone: function() {
      return this.user ? this.user.timezone : null;
    },
    user() {
      return this.$store.state.notes.user;
    },
    categories() {
      if (!this.note.term_list) {
        return false;
      }
      let categories = this.note.term_list;
      categories = categories.substring(1);
      categories = categories.slice(0, -1);

      var count = (categories.match(/\]\[/g) || []).length;
      categories = categories.replace(/\]\[/g, ", ");
      return categories;
    },
    book() {
      return this.$store.state.notes.book;
    },
    noteIsProtectedAndNotUnlocked() {
      return this.note.visibility === this.$store.state.notes.config.visibility.locked && !this.$store.state.notes.unlocked.hasOwnProperty(this.note.book_id);
    }
  },
  methods: {
    oneClick: function(event){
      this.clicks++
      if(this.clicks === 1) {
        var self = this
        this.timer = setTimeout(function() {
          self.clicks = 0
        }, this.delay);
      } else{
        let noteCopy = Object.assign({}, this.note);
        noteCopy.editing = true;
        this.$store.dispatch("aSetNote", noteCopy);
        clearTimeout(this.timer);
        this.clicks = 0;
      }
    },
    toggleOptions(e) {
      e.stopPropagation(); // stop outside click from closing dropdown
      this.showOptions = !this.showOptions;
    },
    async decryptContent() {
      if (!this.$store.state.notes.privateKey) {
        await this.$store.dispatch("SAVE_KEYS_FROM_LOCAL_STORAGE_TO_STATE");
      }
      let noteCopy = Object.assign({}, this.note);
      const decryptedText = await this.$store.dispatch(
        "DECRYPT_TEXT",
        noteCopy.encrypted
      );
      noteCopy.encrypted = decryptedText.data;
      noteCopy.decrypted = true;
      this.$store.dispatch("aSetNote", noteCopy);
    }
  }
};
</script>

<style lang="scss">
.right-15 {
  right: 15px;
}
</style>
